import { cn } from '@/app/lib/utils';

export const getTagButtonClasses = (tag: { isSelected: boolean; isDisabled?: boolean }) =>
  cn(
    'inline-flex h-9 items-center justify-center gap-1 shrink-0 rounded-round px-6 py-2 font-heading text-base font-semibold leading-5 transition-colors cursor-pointer primary-focus',
    !tag.isSelected &&
      !tag.isDisabled &&
      'border bg-white border-secondary-200 text-secondary-400 hover:bg-secondary-50',
    tag.isSelected && !tag.isDisabled && 'border-[1.5px] border-primary bg-white text-primary',
    tag.isDisabled && 'bg-secondary-100 text-secondary-200 border-0 cursor-not-allowed',
  );
